export const buildNumber = '20260320.4';
export const version = 'main';
export const latestCommit = 'f8baf7cc2d74240fdef94161d0017c74ee8af82f';
